<template>
    <div class="col"
        v-show="$welcomeView.isAllowed('viewLinkToSection', to)" >
        <router-link role="button" :class="buttonName" :to="{ name: to}">
                <i class="fa" :class="iconName"></i> {{text}} </router-link>
    </div>
</template>

<script type="text/babel">
import { WelcomeViewPermiter } from '../../../router/perimeters/welcomeViewPermiter.js';

export default {
    name: 'topbarlink',
    props: {
        to: {
            type: [String, Object],
        },
        text: {
            type: String
        },
        buttonName: {
            type: String,
        },
        iconName: {
            type: String
        },
    },
    perimeters: [
        WelcomeViewPermiter
    ]
};
</script>

<style lang="scss" scoped>
 .top-menu a {
        opacity: 1;
        color: #fff;
        transition: opacity 600ms ease;
        width: max-content;
        &:hover {
            opacity: .6;
        }        
    }
    .container {
        display: flex;
        justify-content: space-between;
    }
    .lefticon{
        &:focus{
            box-shadow: none;
        }
        &.btn{
            padding: 0;
            background-color: transparent;
            border: none;
            color: #ffffff;
            height: 100%;
            margin: 0;            
        }
        .icon-cph_iconset_cloudprinthub{
            height: 100%;
            font-size: 50px;
            width: 60px;
            color: #ffffff;
            &:focus{
                outline: none;
            }
        }
        .text{
            height: 50px;
            line-height: 50px;
            font-size: 16px;
            position: absolute;
            top: 0;
            padding-left: 10px;
        }
    }
    .topbar {
        height: 50px;
        @include color('background-color', primary);
    }

    .left, .right {
        width: 50%;
    }

    #dropdownMenuLink {
        cursor: pointer;
    }

    .sidebar-toggler {
        display: block;
        cursor: pointer;
        font-size: 2em;
        margin-left: 1.25rem;
        background-color: transparent;
        @include color('color', background-color-light);
    }

    .options-link {
        font-size: 3rem;
        @include color('color', background-color-light);
    }

    .dropdown-menu {
        right: 0;
        top: 2.5rem;
        left: initial;
        display: block;
    }

    #dropdownMenuButton, .dropdown-item {
        cursor: pointer;
    }

    .dropdown-header {
        .icon {
            font-size: 1.5em;
        }
    }

    .dropdown-item {
        &.activeLanguage {
            text-decoration: underline;
        }
        .icon {
            color: #c4c4c4;
            font-size: 1.5em;
        }
    }
</style>
